import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import { createRoot } from "react-dom/client";
import { initPostHog } from "@/lib/posthog";
import { LandingPage } from "./pages/LandingPage";

const isPostHogEnabled: boolean = initPostHog();

const rootElement: HTMLElement = document.getElementById("root") as HTMLElement;
const rootApp: React.JSX.Element = isPostHogEnabled ? (
  <PostHogProvider client={posthog}>
    <PostHogErrorBoundary>
      <LandingPage />
    </PostHogErrorBoundary>
  </PostHogProvider>
) : (
  <LandingPage />
);

createRoot(rootElement).render(rootApp);
